import { RefObject, createContext } from 'react';

export const NavigationElementsContext = createContext<{
  footerRef?: RefObject<HTMLElement>;
  navbarRef?: RefObject<HTMLElement>;
}>({});
